import { render, staticRenderFns } from "./FabricImageUpload.vue?vue&type=template&id=592de6cc&scoped=true&"
import script from "./FabricImageUpload.vue?vue&type=script&lang=ts&"
export * from "./FabricImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FabricImageUpload.vue?vue&type=style&index=0&id=592de6cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592de6cc",
  null
  
)

export default component.exports